/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Berichte',
    lead: 'Berichte für {{company}}, basierend auf vorhandenen Daten — es werden keine separaten Berichtsdaten gespeichert.',
    noScope: 'Wählen Sie ein Unternehmen aus, um dessen Berichte zu sehen.',
    forbidden: 'Sie dürfen die Berichte dieses Unternehmens nicht sehen.',
  },
  library: {
    title: 'Berichtsbibliothek',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Monatliche Vitalitätstrends',
      description: 'Gesamtzahl der Schritte pro Monat im gesamten Unternehmen.',
    },
    deelnamerapport: {
      title: 'Teilnahmebericht',
      description: 'Wie viele Mitarbeitende aktiv sind, und wie kürzlich.',
    },
    'challenge-resultaten': {
      title: 'Challenge-Ergebnisse',
      description: 'Challenges nach Status und durchschnittlicher Fortschritt der Teilnehmenden.',
    },
    communicatiebereik: {
      title: 'Kommunikationsreichweite',
      description: 'Gesendete, zugestellte und geöffnete Benachrichtigungen.',
    },
    documentgebruik: {
      title: 'Dokumentennutzung',
      description: 'Veröffentlichte/archivierte Dokumente und ihre Gesamtaufrufe.',
    },
  },
  actions: {
    exportCsv: 'CSV exportieren',
    exportPdf: 'PDF exportieren',
  },
  export: {
    pdfFallbackNote:
      'PDF-Export ist noch nicht verfügbar — stattdessen wurde eine CSV-Datei heruntergeladen.',
    error: 'Dieser Bericht konnte nicht exportiert werden.',
  },
} as const;
